<template lang="pug">
.users-guest-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1 {{ $t('planDetailsCardTable.date') }}: {{ formattedDate(item.created_at) }}
      .mb-1 {{ $t('planDetailsCardTable.value') }}:
        span(:class='{ "text-decoration-line-through": hasDiscount(item) }') {{ item.value.formatted }}
        span(v-if='hasDiscount(item)') {{ item.paid_value.formatted }}
      .mb-1 {{ $t('planDetailsCardTable.status') }}: {{ formattedStatus(item.status).text }}
      .mb-0
        a(:href='item.details_url' target='_blank')
          span.owner__organization {{ $t('planDetailsCardTable.viewDetails') }}
    template(v-slot:table-head)
      th(style='width: 30%') {{ $t('planDetailsCardTable.date') }}
      th(style='width: 30%') {{ $t('planDetailsCardTable.value') }}
      th(style='width: 20%') {{ $t('planDetailsCardTable.status') }}
      th(style='width: 20%')
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ formattedDate(item.created_at) }}
      td
        span(:class='{ "text-decoration-line-through": hasDiscount(item) }') {{ item.value.formatted }}
        span(v-if='hasDiscount(item)') &nbsp;{{ item.paid_value.formatted }}
      td
        .alert-simple(:class='formattedStatus(item.status).class') {{ formattedStatus(item.status).text }}
      td
        .text-end
          a(:href='item.details_url' target='_blank')
            span.owner__organization {{ $t('planDetailsCardTable.viewDetails') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import moment from 'moment';

export default {
  name: 'PlanDetailsCardTable',
  components: {
    Icon,
    CardTable,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formattedDate(item) {
      return moment(item).format('DD/MM/YYYY') || null;
    },
    formattedStatus(item) {
      switch (item) {
        case 'created':
          return {
            text: this.$t('planDetailsCardTable.open'),
            class: 'alert-simple-warning',
          };
        case 'pending':
          return {
            text: this.$t('planDetailsCardTable.pending'),
            class: 'alert-simple-warning',
          };
        case 'paid':
          return {
            text: this.$t('planDetailsCardTable.paid'),
            class: 'alert-simple-success',
          };
        case 'rejected':
          return {
            text: this.$t('planDetailsCardTable.rejected'),
            class: 'alert-simple-danger',
          };
        case 'cancelled':
          return {
            text: this.$t('planDetailsCardTable.cancelled'),
            class: 'alert-simple-danger',
          };
        default:
          return {
            text: item,
            class: 'alert-simple-secondary',
          };
      }
    },
    formattedValue(item) {
      if (item.paid_value) {
        return item.paid_value.formatted;
      }

      return item.value.formatted;
    },
    hasDiscount(item) {
      if (!item.discount_value) {
        return false;
      }

      return item.discount_value.amount > 0;
    },
  },
};
</script>

<style lang="stylus">
.users-guest-card-table
  .btn-reinvite-user
    i
      color: #013D52;
  .btn--delete-user
    position: absolute
    top: 0.5rem
    right: 0.5rem
  .owner__organization
    font-weight: 600
    color: #0080A3
</style>
